import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Icon } from "@iconify/react";
import { faqs } from "../../api/HelpCenter";
import { Box, Typography, Button, Skeleton, Collapse } from "@mui/material";

const HelpCenter = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [faqList, setFaqList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await faqs();
        if (response.success) setFaqList(response.data);
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchFaqs();
  }, []);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const contactOptions = [
    {
      label: "support@sunfox.in",
      icon: "material-symbols:mail",
      action: () => window.open("mailto:support@sunfox.in"),
    },
    {
      label: "+91 7060000556",
      icon: "carbon:phone-filled",
      action: () => window.open("tel:+917060000556"),
    },
    {
      label: "+91 7060000556",
      icon: "iconoir:whatsapp-solid",
      action: () => window.open("https://wa.me/917060000556"),
    },
  ];

  return (
    <>
      <Helmet>
        <title>Help Centre - Dashboard</title>
      </Helmet>

      <Box className="main-wrappers">
        <Box
          className="page-wrapper"
          sx={{
            maxHeight: "99vh",
            overflowY: "auto",
            pb: "10px",
            pt: "75px",
            fontFamily: "Figtree",
          }}
        >
          <Box className="content">
            <Box sx={{ fontFamily: "Figtree" }}>
              <Typography
                variant="h4"
                sx={{ fontWeight: "bold", mb: 2, fontFamily: "Figtree" }}
              >
                Help Centre
              </Typography>

              {loading ? (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  {[...Array(4)].map((_, index) => (
                    <Box
                      key={index}
                      sx={{
                        backgroundColor: "var(--app-surface)",
                        borderRadius: "8px",
                        p: 2,
                      }}
                    >
                      <Skeleton variant="text" height={20} width="60%" />
                      <Skeleton variant="text" height={14} width="90%" />
                      <Skeleton variant="text" height={14} width="85%" />
                    </Box>
                  ))}
                </Box>
              ) : (
                faqList.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      backgroundColor: "var(--app-surface)",
                      borderRadius: "12px",
                      border: "1px solid var(--app-border)",
                      boxShadow: "var(--app-shadow)",
                      p: 2,
                      mt: 2.5,
                      mb: 1.5,
                      fontFamily: "Figtree",
                    }}
                  >
                    <Box
                      onClick={() => toggleAccordion(index)}
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                        cursor: "pointer",
                        fontWeight: 500,
                        fontSize: "18px",
                      }}
                    >
                      <Icon
                        icon={
                          openIndex === index ? "tabler:minus" : "tabler:plus"
                        }
                        style={{
                          fontSize: 20,
                          flexShrink: 0,
                          marginTop: 2,
                        }}
                      />

                      {item.question}
                    </Box>

                    <Collapse in={openIndex === index}>
                      <Typography
                        variant="body1"
                        sx={{
                          mt: 1.5,
                          fontSize: "16px",
                          color: "var(--app-text-muted)",
                          fontFamily: "Figtree",
                        }}
                      >
                        {item.answer}
                      </Typography>
                    </Collapse>
                  </Box>
                ))
              )}

              {/* Contact Us Section */}
              <Box sx={{ mt: 6 }}>
                <Typography
                  variant="h6"
                  sx={{
                    mt: 5,
                    mb: 2.5,
                    fontWeight: "bold",
                    fontSize: "24px",
                    fontFamily: "Figtree",
                  }}
                >
                  Still have doubts? Contact Us
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "16px",
                  }}
                >
                  {contactOptions.map((option, index) => (
                    <Button
                      key={index}
                      onClick={option.action}
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        backgroundColor: "var(--app-surface-2)",
                        fontWeight: 500,
                        fontSize: "17px",
                        color: "var(--app-text)",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        borderRadius: "6px",
                        p: "16px 19px",
                        gap: "14px",
                        minWidth: "220px",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "var(--app-border)",
                        },
                      }}
                    >
                      <Icon icon={option.icon} width="25" height="25" />
                      {option.label}
                    </Button>
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Contact Section */}
        </Box>
      </Box>
    </>
  );
};

export default HelpCenter;
